/** Shared V2 → legacy flat liabilities view (matches assetsliabilities/read.go loan list). */

import { mapV2OwnershipToLegacyShownType } from "./liabilityOwnershipV2"

export const mapLegacyLoan = (loan, primaryPartyId = "") => {
    const legacyOwnership = mapV2OwnershipToLegacyShownType(loan, primaryPartyId)
    return {
        ...(loan || {}),
        name: loan?.name || loan?.creditor || "",
        monthlypayment: loan?.monthlyPayment || loan?.monthlypayment || "",
        remainingbalance: loan?.remainingBalance || loan?.remainingbalance || "",
        paidoffatclosing: loan?.paidOffAtClosing || loan?.paidoffatclosing || "",
        monthlyamount: loan?.monthlyAmount || loan?.monthlyamount || "",
        forsubjectproperty: loan?.forSubjectProperty ?? loan?.forsubjectproperty ?? false,
        satisfiedupon: loan?.satisfiedUpon || loan?.satisfiedupon || "",
        accountnumber: loan?.accountNumber || loan?.accountnumber || "",
        rate: loan?.rate || "",
        ownership: legacyOwnership,
        creditliabilityShownOwnershipType: legacyOwnership,
        ownerPartyIds: loan?.ownerPartyIds || [],
    }
}

export const mapLegacyNewLoan = (loan) => ({
    ...(loan || {}),
    creditor: loan?.creditor || loan?.name || "",
    monthlyamount: loan?.monthlyAmount || loan?.monthlyamount || "",
})

export const dedupeLoansByKey = (loans) => {
    const seen = new Set()
    return (loans || []).filter((loan) => {
        const key = loan?.key
            || loan?.accountnumber
            || `${loan?.name || ""}:${loan?.monthlypayment || ""}:${loan?.remainingbalance || ""}`
        if (seen.has(key)) return false
        seen.add(key)
        return true
    })
}

export const participantOrderV2 = (application) => (
    Array.isArray(application?.participantOrder) && application.participantOrder.length
        ? application.participantOrder
        : Object.keys(application?.participantsById || {})
)

/** Legacy assetsandliabilities.loans = all loan_liability_loans (2c + subject + REO mortgages). */
export const collectLegacyLiabilities = (application) => {
    const order = participantOrderV2(application)
    const primaryPartyId = application?.primaryPartyId || order[0] || ""
    const mapLoan = (loan) => mapLegacyLoan(loan, primaryPartyId)
    const liabilitiesByPartyId = application?.finance?.liabilitiesByPartyId || {}
    const realEstateByPartyId = application?.finance?.realEstateByPartyId || {}
    const liabilityLoans = order.flatMap((partyId) =>
        (liabilitiesByPartyId[partyId]?.loans || []).map(mapLoan)
    )
    const subjectLoans = (application?.property?.loans || []).map(mapLoan)
    const reoMortgageLoans = order.flatMap((partyId) =>
        (realEstateByPartyId[partyId]?.properties || []).flatMap((property) =>
            (property.loans || []).map(mapLoan)
        )
    )
    const primaryId = application?.primaryPartyId || order[0] || ""
    const newMortgageSource = primaryId && liabilitiesByPartyId[primaryId]?.newMortgages
        ? liabilitiesByPartyId[primaryId].newMortgages
        : order.flatMap((partyId) => liabilitiesByPartyId[partyId]?.newMortgages || [])
    return {
        loans: dedupeLoansByKey([...liabilityLoans, ...subjectLoans, ...reoMortgageLoans]),
        newloans: dedupeLoansByKey(newMortgageSource.map(mapLegacyNewLoan)),
    }
}
